import _extends from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends";
import _typeof from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/typeof";
import _regeneratorRuntime from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonContents from "~/components/CommonContents";
import CommonContent from "~/components/CommonContent";
import PageTitle from "~/components/PageTitle";
import CommonFooter from "~/components/CommonFooter";
import { mapState } from "vuex";
export default {
  components: {
    CommonContents: CommonContents,
    PageTitle: PageTitle,
    CommonFooter: CommonFooter,
    CommonContent: CommonContent
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var params = _ref.params,
          store = _ref.store,
          query = _ref.query;
      var result, rel;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store.dispatch("getPageDetail", { id: params.id, lang: query.lang });

            case 2:
              result = _context.sent;
              _context.next = 5;
              return store.dispatch('getPageData', { id: 9, lang: query.lang });

            case 5:
              rel = _context.sent;
              return _context.abrupt("return", { pageData: result, relData: rel });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      meta: "all",
      idx: 0
    };
  },

  methods: {
    toggle: function toggle(index, meta) {
      this.idx = index;
      this.meta = meta;
    },
    unique: function unique(array) {
      var n = {},
          r = [],
          len = array.length,
          val,
          type;
      for (var i = 0; i < array.length; i++) {
        val = array[i];
        type = typeof val === "undefined" ? "undefined" : _typeof(val);
        if (!n[val]) {
          n[val] = [type];
          if (val !== "") {
            r.push(val);
          }
        } else if (n[val].indexOf(type) < 0) {
          n[val].push(type);
          r.push(val);
        }
      }
      return r;
    }
  },
  computed: _extends({}, mapState(["winHeight", 'lang']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + "px"
      };
    },
    projectName: function projectName() {
      switch (this.$route.params.id) {
        case "luo":
          return "罗红艺术馆";
          break;
        case "yan":
          return "雁栖湖";
          break;
        case "zhuag":
          return "华彬庄园";
          break;
        case "ting":
          return "私家庭院";
          break;
      }
    },
    types: function types() {
      var type = this.pageData.imgList.map(function (val) {
        return val.title;
      });
      return this.unique(type);
    },
    relFil: function relFil() {
      var _this = this;

      var newArr = this.relData.filter(function (val) {
        return val.id !== _this.$route.params.id;
      });

      var arr = [];
      var key = function key() {
        if (arr.length === 2) {
          if (arr[0] !== arr[1]) {
            return;
          } else {
            arr.pop();
          }
        }
        arr.push(Math.floor(Math.random() * newArr.length));
        key();
      };
      key();
      return newArr.filter(function (val, key) {
        return key === arr[0] || key === arr[1];
      });
    },
    pro: function pro() {
      if (this.lang === 'en') {
        return 'Project';
      } else {
        return '项  目';
      }
    },
    more: function more() {
      if (this.lang === 'en') {
        return 'More';
      } else {
        return '更多项目';
      }
    },
    all: function all() {
      if (this.lang === 'en') {
        return 'All';
      } else {
        return '全部';
      }
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    document.addEventListener("WeixinJSBridgeReady", function () {
      WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
        document.getElementById("mobile_video").play();
      });
    }, false);
    $(".project-detail_show img").each(function (index, val) {

      // if (this.naturalWidth > this.naturalHeight) {
      //   this.setAttribute('id', 'wide')
      // } else if (this.naturalWidth > this.naturalHeight) {
      //   this.setAttribute('id', 'narrow')
      // }
      if (this.width > this.height) {
        this.setAttribute("id", "wide");
      } else {
        this.setAttribute("id", "narrow");
      }
      val.onload = function () {
        if (this.width > this.height) {
          this.setAttribute("id", "wide");
        } else {
          this.setAttribute("id", "narrow");
        }
      };
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/_id.vue
// module chunks = 1